

<template>

    <div class="page-main-header row listing-desktophide" id="top-page-header">
        <p id="mobile-app_back_button" @click="goBack">
            <svg width="12" height="22" viewBox="0 0 12 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.8166 21.8129C11.1054 22.0835 11.5517 22.0564 11.8143 21.7588C12.0768 21.4611 12.0505 21.0011 11.7617 20.7304L1.60161 11.2592C1.33908 11.0157 1.33908 10.6639 1.60161 10.4204L11.7617 1.27388C12.0505 1.00327 12.0768 0.543241 11.8405 0.245575C11.578 -0.0520918 11.1317 -0.0791522 10.8429 0.164393L0.682738 9.33794C-0.209884 10.1498 -0.236137 11.5028 0.656484 12.3417L10.8166 21.8129Z" fill="white" />
            </svg>


        </p>
        <div href="!#" @click="toggleSlider" id="sidebar-toggle" class="toggle-sidebar col-auto" checked="checked">
            <span class="for-icon">
                <svg class="mobile-hide" width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 12V10H18V12H0ZM0 7V5H18V7H0ZM0 2V0H18V2H0Z" fill="#fff" />
                </svg>

                <svg class="mobile-show" width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 12V10H18V12H0ZM0 7V5H18V7H0ZM0 2V0H18V2H0Z" fill="#000" />
                </svg>

            </span>
        </div>
        <div class="nav-right col p-0 header-nav-right">
            <div v-if="(assetType && (userType != 'usertype01' && userType != 'usertype06' && companyId!='29E9C4AD-9AF2-4757-A001-AC34690B1A12'))" class="header-asset-type" aria-label="Selected asset type">
                <span class="header-asset-type-label">Asset Type:</span>
                <span class="header-asset-type-value">{{ assetType }}</span>
            </div>
            <ul class="header-menu">
                <!-- <li>
                                <div class="d-md-none mobile-search">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-search"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
                    </div>
                    <div class="form-group search-form">
                        <input type="text" class="form-control" :placeholder="$t('header.search')">
                    </div>
                </li>-->
                <li class="px-1">
                    <!--<span class="for-icon"><i class="fa fa-moon"></i></span>-->
                </li>
                <li id="mobile-theme-change" class="d-none">
                    <a href="javascript:void(0)" @click="loadCssForTheme">
                        <span class="for-icon">
                            <i id="regularTheme" class="fa fa-sun d-none"></i>
                            <i id="light" class="fa fa-moon" style="display:none"></i>
                        </span>
                    </a>
                </li>
                <!-- <li>
                    <Dropdown v-model="SelectedLanguage"
                              :options="LanguageList"
                              optionValue="value"
                              optionLabel="text"
                              :placeholder="$t('placeholder.SelectLanguage')"
                              @change="ChangeLanguage">
                    </Dropdown>
                </li>-->
                <!--<button type="button"
                        class="btn btn-gradient color-4 mx-1 float-end"
                        @click="openCommunication">
                    <i class="fa fa-comments" aria-hidden="true"></i>
                    Communication
                </button>-->
                <li class="full-screen-li"><a title="Communication" href="#!" @click="openCommunication" v-if="companyId!='29E9C4AD-9AF2-4757-A001-AC34690B1A12'"><span class="for-icon"><i class="fa fa-comments"></i></span></a></li>


                <li class="full-screen-li"><a :title="fullscreenMsg" href="#!" @click="ToggleFullScreen"><span class="for-icon"><i class="fa fa-expand"></i></span></a></li>
                <li class="onhover-dropdown notification-box" v-if="$filters.IsNull(NotificationPermission) != null && NotificationPermission.roleModuleReadFlag==true">
                    <a href="javascript:void(0)" @click="GoToManageNotification" v-on:mouseover="getUnreadNotificationCount">
                        <span class="for-icon"><i class="fa fa-bell"></i></span>
                        <span class="label label-shadow label-pill notification-badge jquert_text">{{notificationcount}}</span>
                    </a>
                    <div class="notification-dropdown onhover-show-div">
                        <div class="dropdown-title">
                            <h6>{{$t('sidebar.Notifications')}}</h6>
                            <router-link to="/ManageNotification">{{$t('common.Showall')}}</router-link>
                        </div>
                        <ul>
                            <li class="notification">{{$t('ManageCompany.Total Unread Notifications')}}: {{notificationcount}}</li>

                        </ul>
                    </div>
                </li>

                <li class="top_bar">
                    <div class="user-profile">
                        <div class="media">
                            <div class="change-pic">
                                <router-link v-if="userType == 'usertype01' || userType == 'usertype02' || userType == 'usertype04' ||userType == 'usertype06' ||userType == 'usertype11' ||userType == 'usertype12' " to="/userProfile" href="Javascript:;">
                                    <img :src="imageLink" class="img-fluid" alt="" v-if="$filters.IsNull(imageLink)!=null">
                                    <span class="avatarttext" v-if="$filters.IsNull(imageLink)==null">{{$filters.FirstAndLastNameAlpha(name.firstName,name.lastName)}}</span>
                                </router-link>
                                <router-link v-else to="/userProfile">
                                    <img :src="imageLink" class="img-fluid" alt="" v-if="$filters.IsNull(imageLink)!=null">
                                    <span class="avatarttext" v-if="$filters.IsNull(imageLink)==null">{{$filters.FirstAndLastNameAlpha(name.firstName,name.lastName)}}</span>
                                </router-link>
                            </div>
                            <div class="media-body">
                                <router-link to="/userProfile" @click="CheckRoute" href="javascript:;" v-if="(companyId != '526C12D1-97B1-4F5A-A454-147AAC613505' && companyId != '526c12d1-97b1-4f5a-a454-147aac613505')&&(userType == 'usertype01' || userType == 'usertype02' || userType == 'usertype04' ||userType == 'usertype06' ||userType == 'usertype11' ||userType == 'usertype12')"><h6>{{name.firstName}} {{name.lastName}}</h6></router-link>
                                <router-link to="/userProfile" @click="CheckRoute" href="javascript:;" v-else><h6>{{name.firstName}} {{name.lastName}}</h6></router-link>

                                <h6 v-if="companyId == '526C12D1-97B1-4F5A-A454-147AAC613505' || companyId == '526c12d1-97b1-4f5a-a454-147aac613505'">{{name.firstName}} {{name.lastName}}</h6>
                                <span v-if="headerData!=null && headerData!='' && headerData.userType!='Buyer'  && headerData.userType!='Seller' && headerData.userType!='Ambassador' && headerData.userType!='Realtor'">
                                    {{headerData.userType}}
                                </span>
                                <span v-if="(headerData!=null && headerData!='' && (headerData.userType=='Buyer'  || headerData.userType=='Ambassador' || headerData.userType=='Seller' || headerData.userType=='Realtor'))">
                                    {{$t(`sidebar.Member`)}}
                                </span>
                            </div>
                        </div>
                    </div>


                </li>

                <li><a href="javascript:void(0);" @click="logout()"> <span class="for-icon"><i class="fa fa-power-off"></i></span></a></li>

            </ul>
        </div>

        <div class="logoutopt"><a href="javascript:void(0);" @click="logout()"> <span class="for-icon"><i class="fa fa-power-off"></i></span></a></div>

    </div>
    <loading v-model:active="isLoading" />
    <div class="modal-container " v-if="isvisible">
        <div class="modal-dialog modal-dialog modal-lg modal-dialog-centered deleteAccount">

            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title" style="color:black;">{{$t('ManageCompany.DeleteAccount')}}</h4>
                    <a class="modal-close" @click="CloseModel()"><i class="fa fa-times"></i></a>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <Form class="row" @submit="deleteAccount()" autocomplete="off" :validation-schema="schema" v-slot="{ errors }">
                            <div class="form-group col-md-12 col-sm-12" style="word-wrap: break-word;">
                                <div class="input-group">
                                    <ul>
                                        <li class="d-block">
                                            <i class="fa fa-check me-2"></i><span class="font-danger">
                                                {{$t('ManageCompany.DeletedPermanentlyCannotRecovered')}}
                                            </span>
                                        </li>
                                        <li class="d-block"><i class="fa fa-check me-2"></i>{{$t('ManageCompany.PleaseConfirmEnteringBelow')}}</li>
                                    </ul>
                                </div>
                                <div class="form-group">

                                    <Field type="text" :placeholder="$t('placeholder.username') + ' *'" name="username" class="form-control form-control-lg"
                                           v-model="form.username" :class="{ 'is-invalid': errors.username }" />
                                    <div class="invalid-feedback">{{errors.username}}</div>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button type="submit" class="btn btn-pill  ms-2 btn-gradient color-4 ">{{$t('ManageCompany.DeleteAccount')}}</button>
                                <button class="btn btn-pill btn-danger" @click="CloseModel()">{{$t('common.Close')}}</button>
                            </div>
                        </Form>
                    </div>
                </div>
            </div>
        </div>

    </div>

    <!-- <div v-if="showBottomNav" class="bottom-nav"> -->

    <div v-if="showBottomNav && $route.path !== '/meetings/add' && $route.path !== '/ticket/addTicket'" class="bottom-nav">

        <router-link to="/dashboard" v-slot="{ isActive }">

            <span>
                <i class="fa fa-house" :class="{ 'active-icon': isActive }"></i>
            </span>
            <small>Dashboard</small>
        </router-link>

        <router-link to="/ticket" v-slot="{ isActive }">
            <span><i class="fa fa-wrench" :class="{ 'active-icon': isActive }"></i></span>
            <small>Tickets</small>
        </router-link>
        <router-link to="/meetings" v-slot="{ isActive }">
            <span><i class="fa fa-calendar-alt" :class="{ 'active-icon': isActive }"></i></span>
            <small>Meetings</small>
        </router-link>
        <router-link to="/expenses"
                     :class="{ 'active-link': $route.path.startsWith('/expenses') }">
            <span>
                <i class="fa fa-file-invoice-dollar"></i>
            </span>
            <small>Expenses</small>
        </router-link>

        <router-link to="/voting-proposals" v-slot="{ isActive }">
            <span>
                <i class="fa fa-store" :class="{ 'active-icon': isActive }"></i>
            </span>
            <small>Votes</small>
        </router-link>

    </div>

</template>
<script>
    import UserService from '@/service/user.service';
    import UserServiceNew from '@/service/userfrontend/ContactServices';
    import SimpleDialog from "@/views/shared/SimpleDialog.vue";
    /*    import Sidebar from "@/layouts/sidebar/Sidebar.vue";*/
    import { createConfirmDialog } from "vuejs-confirm-dialog";
    import common from '../../views/shared/common/commonuses.js';
    import { Form, Field } from 'vee-validate';
    import * as Yup from 'yup';
    import { initShellLayoutWhenReady, syncSidebarShellState } from '@/helpers/shellLayout';
    import {
        COMPANY_LOGOS_UPDATED_EVENT,
        applyLogoImgDomSrc,
        resolveSidebarLogoDisplaySrc
    } from '@/helpers/companyLogos';
    export default {
        name: 'HelloWorld',
        props: {
            msg: String

        },

        components: {
            Form,
            Field/*, Sidebar*/
        },
        computed: {
            showBottomNav() {
                const allowedRoutes = [
                    '/dashboard',
                    '/assetDocumentProcess',
                    '/ownedProperties',
                    '/VactionSwapMarketplace',
                    '/voting-proposals',
                    '/ticket',
                    '/meetings',
                    '/expenses',
                    '/paymenttracking',
                    '/expenses/voting',
                    '/expenses/dues',
                    '/ManageNotification'
                ];

                return allowedRoutes.some(route =>
                    this.$route.path === route ||
                    this.$route.path.startsWith(`${route}/`)
                );
            }
        },
        data() {
            const schema = Yup.object().shape({
                username: Yup.string()
                    .required(this.$t('Validation.Usernamed')),


            });
            var UserInfo = JSON.parse(localStorage.getItem('userinfo'));
            const userType = UserInfo.data.userType;
            let name = {
                firstName: '',
                lastName: ''
            }

            const NotificationPermission = common.getPermission(7012);
            return {
                isvisible: false,
                data: '',
                isLoading: false,
                headerData: null,
                companyId: localStorage.getItem('companyId'),
                imageLink: null,
                fullscreenMsg: this.$t('ManageCompany.FullScreen'),
                userType,
                notificationcount: 0,
                NotificationPermission,
                logoPrimary: localStorage.getItem('primaryLogo'),
                logoSecondary: null,
                username: '',
                LanguageList: '',
                SelectedLanguage: null,
                form: {
                    username: ""

                },
                schema,
                side: false,
                isMobile: false,
                assetType: localStorage.getItem('assetType')
            }
        },
        async created() {



            this.refreshLogosFromStorage();
            this.GetHeaderData();
            if (localStorage.getItem('userinfo') != null && localStorage.getItem('userinfo') != "") {
                var data = JSON.parse(localStorage.getItem('userinfo')).data;
                this.name = data;
            }
            await this.getlanguageList();
            //localStorage.setItem("Language", "en");
            this.getUnreadNotificationCount();

            if (localStorage.getItem('Language') == 'en') {
                this.SelectedLanguage = '364697eb-c5d6-44fa-8c08-ece45aed1844';
            } else {
                this.SelectedLanguage = 'cdf82d9b-07af-427e-9261-a3f45bc98f8f';
            }

            if (localStorage.getItem('adminTheme') == 'regularTheme' || localStorage.getItem('adminTheme') == null) {

                document.getElementById("regularTheme").style.display = "block";
                document.getElementById("light").style.display = "none";

            } else {
                document.getElementById("regularTheme").style.display = "none";
                document.getElementById("light").style.display = "block";

            }

        },
        mounted() {
            window.addEventListener("resize", this.ForSrceenChange);
            this.checkMobileView();
            this.refreshAssetTypeFromStorage();
            this.$nextTick(() => {
                initShellLayoutWhenReady();
            });
            window.addEventListener('resize', this.checkMobileView);
            this._onCompanyLogosUpdated = () => {
                this.refreshLogosFromStorage();
            };
            window.addEventListener(COMPANY_LOGOS_UPDATED_EVENT, this._onCompanyLogosUpdated);
        },
        unmounted() {
            window.removeEventListener("resize", this.ForSrceenChange);
            window.removeEventListener('resize', this.checkMobileView);
            if (this._onCompanyLogosUpdated) {
                window.removeEventListener(COMPANY_LOGOS_UPDATED_EVENT, this._onCompanyLogosUpdated);
            }
        },
        methods: {
            openCommunication() {
                const fullUrl = UserService.getUrlForDynamic();
                if (!fullUrl) {
                    this.$toast.error('Communication URL or key is missing.');
                    return;
                }
                window.open(fullUrl, '_blank', 'noopener,noreferrer');
            },
            refreshAssetTypeFromStorage() {
                this.assetType = localStorage.getItem('assetType');
            },
            refreshLogosFromStorage() {
                this.logoPrimary = localStorage.getItem('primaryLogo');
                this.logoSecondary = localStorage.getItem('secondaryLogo');
                applyLogoImgDomSrc(resolveSidebarLogoDisplaySrc(localStorage.getItem('companyId')));
            },
            goBack() {
                this.$router.back()
            },
            GoToManageNotification() {
                this.$router.push({ path: '/ManageNotification' });
            },
            CheckRoute() {
                let storedData = JSON.parse(localStorage.getItem('moduleList'));
                if (storedData != null) {
                    let moduleFound = storedData.find(module => module.moduleCode === "2312");
                    let loginUserId = localStorage.getItem('userId')
                    // If module is found, display it or use it
                    if (loginUserId != null && loginUserId != "") {
                        if (moduleFound) {
                            //window.location.href = "/dashboard";
                        } else {
                            // If module is not found, show a message
                            //window.location.href = "/BookingListing";
                            // if (routePath == '/dashboard') {
                            if ((localStorage.getItem('themeName') == 'GolfCart' || localStorage.getItem('themeName') == 'Restaurant' || localStorage.getItem('themeName') == 'SpaServices') && localStorage.getItem('userType') == 'usertype05') {
                                debugger
                                this.$router.push("/userProfile");
                            }
                            else {
                                this.$router.push("/userProfile");
                            }

                            //next();
                            // }
                        }
                    }
                }
            },
            loadCssForTheme() {
                debugger

                var LogoImage=null
                var regularThemeImage = localStorage.getItem('secondaryLogo');
                var light = localStorage.getItem('primaryLogo');
                if (localStorage.getItem('adminTheme') == 'regularTheme' || localStorage.getItem('adminTheme') == null) {
                    localStorage.removeItem("adminTheme");
                    localStorage.setItem("adminTheme", "light");
                    document.getElementById('body').className = "light";
                    document.getElementById("body").classList.remove("regularTheme");
                    //import("../../assets/css/css/admin-light.css")
                    document.getElementById("regularTheme").style.display = "none";
                    document.getElementById("light").style.display = "block";
                    LogoImage = document.getElementById('logoimg');
                    LogoImage.src = regularThemeImage;

                    document.getElementById("logoimg").classList.remove("logoPrimary");


                } else {
                    localStorage.removeItem("adminTheme");
                    localStorage.setItem("adminTheme", "regularTheme");
                    document.getElementById('body').className = "regularTheme";
                    document.getElementById("body").classList.remove("light");

                    document.getElementById("regularTheme").style.display = "block";
                    document.getElementById("light").style.display = "none";
                    //import("../../assets/css/css/admin.css")
                    LogoImage = document.getElementById("logoimg")
                    LogoImage.src = light;


                }
                document.getElementById('body').className = "regularTheme"; // to set a default 
                /*   this.$emit('childevent', 'Hello from child!');*/
                //window.location.reload();
            },
            GetSelectedLanguage() {
                // this.SelectedLanguage = "364697eb-c5d6-44fa-8c08-ece45aed1844";
                var item = this.LanguageList.find(x => x.value == this.SelectedLanguage);
                localStorage.removeItem("Language");
                localStorage.setItem("Language", item.masterName);
                //UserServiceNew.GetSelectedLanguage(localStorage.getItem('userId'), localStorage.getItem("companyId")).then(res => {
                //    console.log('GetSelectedLanguage', res.data)

                //})

            },
            deleteAccount() {
                if (this.form.username == (JSON.parse(localStorage.getItem('userinfo')).data.userName)) {
                    this.isvisible = false;;
                    const { reveal, onConfirm, onCancel } = createConfirmDialog(SimpleDialog, {
                        question: `${this.$t('ConfirmMessage.DeleteAccountConfirm')}?`,
                        header: `${this.$t('ConfirmMessage.DeleteAccount')}`,
                        cancel: `${this.$t('ConfirmMessage.Cancel')}`,
                        confirm: `${this.$t('ConfirmMessage.Ok')}`,
                    });


                    onConfirm(() => {

                        this.isLoading = true;
                        if (this.form.username == (JSON.parse(localStorage.getItem('userinfo')).data.userName)) {
                            UserServiceNew.deletecompanyuser('AspNetUsers', localStorage.getItem('userId'), this.form.username, localStorage.getItem('userId'), localStorage.getItem("companyId")).then(r => {
                                console.warn(r);
                                this.$toast.success(this.$t('Toaster.AccountDeletedSuccessfully'));
                                localStorage.clear();
                                window.location.href = 'login';
                                this.isLoading = false;
                            })

                        } else {
                            this.$toast.error(this.$t('Toaster.UsernameNotMatched'));
                            this.isLoading = false;
                            this.isvisible = true;
                        }


                    }), onCancel(() => {
                        this.isvisible = true;
                        this.isLoding = false;

                    }),

                        reveal(() => {
                            this.isLoding = false;
                        });

                } else {

                    this.$toast.error(this.$t('Toaster.UsernameNotMatched'));
                }
            },

            CloseModel() {
                this.isvisible = false
            },
            getUnreadNotificationCount() {
                UserService.getUnreadNotification(localStorage.getItem('userId')).then(res => {
                    console.log('notifi', res)
                    this.notificationcount = res.data.notificationcount;
                })
            },

            ForSrceenChange() {
                syncSidebarShellState();
            },
            async logout() {
                try {
                    /*const IPAddress = await UserService.GetIPAddress();*/
                    const { reveal, onConfirm } = createConfirmDialog(SimpleDialog, {
                        question: `${this.$t('ConfirmMessage.LogoutConfirm')}`,
                        header: `${this.$t('ConfirmMessage.Logout')}`,
                        cancel: `${this.$t('ConfirmMessage.Cancel')}`,
                        confirm: `${this.$t('ConfirmMessage.Logout')}`,
                    });

                    onConfirm(() => {
                        this.isLoading = true;
                        UserService.LogoutHistory(localStorage.getItem('userId'), localStorage.getItem("usedcurrentIP")).then(res => {
                        })
                        UserService.Logout(localStorage.getItem('userId')).then(res => {
                        })
                        if (document.getElementById('sidebar') != null) {
                            document.getElementById('sidebar').setAttribute("class", "sidebar js-sidebar collapsed");
                            if (document.getElementById('main_full') != null) {
                                document.getElementById('main_full').setAttribute("class", "main full-section-cc");
                            }
                        }

                        setTimeout(() => {
                            let userType = JSON.parse(localStorage.getItem('userinfo')).data.userType;
                            let companyUrl = localStorage.getItem('companyUrl')
                            let backOrigin = localStorage.getItem('backOrigin')
                            var sessionData = localStorage.getItem('adminTheme');
                            localStorage.clear();
                            localStorage.setItem("adminTheme", sessionData);
                            if ((userType == ('usertype07') || userType == ('usertype05') || userType == ('usertype10') || userType == ('usertype03')
                                || userType == ('usertype09') || userType == ('usertype11') || userType == ('usertype12'))
                                && this.$filters.IsNull(companyUrl, true, null) != null) {
                                if (backOrigin != null && backOrigin != '') {

                                    window.location.assign(`https://${backOrigin}/home`)
                                }
                                else if (this.$custConfig.companyPortalUrl != null && this.$custConfig.companyPortalUrl != undefined) {
                                    window.location.assign(`${this.$custConfig.companyPortalUrl}/logoutRedirect/${companyUrl}`)
                                } else {
                                    window.location.href = "/login";
                                }
                            }
                            else {
                                window.location.href = "/login";
                            }


                            this.$toast.success(this.$t('Toaster.SessionLogout'));
                        }, 500);
                    });
                    reveal(() => {
                        this.data = "";
                    });
                } catch (ex) {
                    console.log("messagessssssssssss", ex.Message)
                }


            },

            GetHeaderData() {

                UserService.getHeaderData(localStorage.getItem("userId"), '00Test').then(res => {
                    this.headerData = res.data;
                    this.imageLink = res.data.profilePic;

                })
            },
            ToggleFullScreen() {
                //this.$refs.catpic.requestFullscreen();
                if ((document.fullScreenElement && document.fullScreenElement !== null) || (!document.mozFullScreen && !document.webkitIsFullScreen)) {
                    this.fullscreenMsg = this.$t('ManageCompany.ExitFullScreen');
                    if (document.documentElement.requestFullScreen) {
                        document.documentElement.requestFullScreen();
                    } else if (document.documentElement.mozRequestFullScreen) {
                        document.documentElement.mozRequestFullScreen();
                    } else if (document.documentElement.webkitRequestFullScreen) {
                        document.documentElement.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
                    }
                } else {
                    this.fullscreenMsg = this.$t('ManageCompany.FullScreen');
                    if (document.cancelFullScreen) {
                        document.cancelFullScreen();
                    } else if (document.mozCancelFullScreen) {
                        document.mozCancelFullScreen();
                    } else if (document.webkitCancelFullScreen) {
                        document.webkitCancelFullScreen();
                    }
                }
            },
            toggleSlider() {
                const headerElement = document.getElementById('top-page-header');
                const sideElement = document.getElementById('nav-page-sidebar');
                const isNowOpen = !sideElement.classList.contains('close_icon');

                headerElement.classList.toggle('close_icon');
                sideElement.classList.toggle('close_icon');

                if (!isNowOpen && this.isMobile) {
                    document.addEventListener('click', this.handleOutsideClick);
                } else if(this.isMobile) {
                    document.removeEventListener('click', this.handleOutsideClick);
                }
            },
            checkMobileView() {
                this.isMobile = window.innerWidth <= 768;
            },
            handleOutsideClick(event) {
                const sidebar = document.getElementById('nav-page-sidebar');
                const header = document.getElementById('top-page-header');
                const toggleButton = document.getElementById('sidebar-toggle');
                if (!sidebar || !toggleButton) return;
                if (!sidebar.contains(event.target) && !toggleButton.contains(event.target)) {
                    sidebar.classList.add('close_icon');
                    if (header) {
                        header.classList.add('close_icon');
                    }
                    document.removeEventListener('click', this.handleOutsideClick);
                }
            },
            getlanguageList() {
                UserService.GetLanguageList('Language', 'Language', localStorage.getItem("userId"))
                    .then(response => {
                        this.LanguageList = response.data;
                        console.log('sds', this.LanguageList);
                        console.log(response)
                        this.GetSelectedLanguage();
                    });
            },
            ChangeLanguage() {
                debugger;
                var item = this.LanguageList.find(x => x.value == this.SelectedLanguage);
                let model = {
                    userId: localStorage.getItem("userId"),
                    companyId: localStorage.getItem("companyId"),
                    SelectedLanguage: this.SelectedLanguage
                }
                localStorage.removeItem("Language");
                localStorage.removeItem("LanguageId");
                localStorage.setItem("Language", item.masterName);
                localStorage.setItem("LanguageId", item.value);
                this.$router.go(0);
                //UserService.UpdateLanguageId(model)
                //    .then(response => {
                //        //this.$toast.success("");
                //        localStorage.removeItem("Language");
                //        localStorage.setItem("Language", item.masterName);
                //        this.$router.go(0);
                //    });
            }
        }
    }
</script>

<style scoped>
.header-nav-right {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 16px;
}

.header-asset-type {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
    padding: 8px 16px;
    background: linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%);
    border: 1px solid #e5e8f0;
    border-radius: 999px;
    box-shadow: 0 1px 2px rgba(26, 39, 66, 0.04);
}

.header-asset-type-label {
    font-size: 13px;
    font-weight: 500;
    line-height: 1;
    color: #5a6884;
    white-space: nowrap;
}

.header-asset-type-value {
    font-size: 14px;
    font-weight: 700;
    line-height: 1;
    color: #1a2742;
    white-space: nowrap;
}

@media (max-width: 768px) {
    .header-nav-right {
        gap: 10px;
    }

    .header-asset-type {
        padding: 7px 14px;
    }

    .header-asset-type-label {
        font-size: 12px;
    }

    .header-asset-type-value {
        font-size: 13px;
    }
}

@media (max-width: 640px) {
    .header-asset-type {
        padding: 6px 12px;
        gap: 6px;
    }

    .header-asset-type-label {
        font-size: 11px;
    }

    .header-asset-type-value {
        font-size: 12px;
    }
}
</style>
